import { useEffect } from 'react';

interface JsonLdProps {
  id: string;
  data: object;
}

export default function JsonLd({ id, data }: JsonLdProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return null;
}
